import { render, staticRenderFns } from "./customerEdit.vue?vue&type=template&id=21cf3a5a&"
import script from "./customerEdit.vue?vue&type=script&lang=js&"
export * from "./customerEdit.vue?vue&type=script&lang=js&"
import style0 from "./customerEdit.vue?vue&type=style&index=0&id=21cf3a5a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports